import axios from '@/libs/api.request'
export const getWeather = (adcode) => {
    return axios.request({
        url: `https://restapi.amap.com/v3/weather/weatherInfo?key=bba6b47468e7836397324532846651bf&city=${adcode}`,
        method: 'get'
    })
}

export const getLocation = () => {
    return axios.request({
        url: 'https://restapi.amap.com/v3/ip?key=bba6b47468e7836397324532846651bf',
        method: 'get'
    })
}

export const getTopHome = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/index/getTopHome',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getMiddleHome = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/index/getMiddleHome',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getHomeBottom = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/index/getHomeBottom',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
